namespace RedBullMOBILE360.AutomaticReports {
    export interface ReportForm {
        ReportChannel: Serenity.EnumEditor;
        Subject: Serenity.StringEditor;
        Template: Serenity.TextAreaEditor;
        Schedule: Serenity.StringEditor;
        IsEnabled: Serenity.BooleanEditor;
        Recipients: Serenity.StringEditor;
    }

    export class ReportForm extends Serenity.PrefixedContext {
        static formKey = 'AutomaticReports.Report';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportForm.init)  {
                ReportForm.init = true;

                var s = Serenity;
                var w0 = s.EnumEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(ReportForm, [
                    'ReportChannel', w0,
                    'Subject', w1,
                    'Template', w2,
                    'Schedule', w1,
                    'IsEnabled', w3,
                    'Recipients', w1
                ]);
            }
        }
    }
}
